// Toast.tsx
import React from "react";
import { errorIcon, successGreenIcon, warningIcon } from "../assets/images";

export enum ToastType {
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
}

export interface ToastContainerProps {
  type: ToastType;
  heading?: string;
  styles?: any;
  description: string;
}

export const toastHeadingMapper = {
  [ToastType.INFO]: "Info",
  [ToastType.SUCCESS]: "Success",
  [ToastType.ERROR]: "Error",
  [ToastType.WARNING]: "Warning",
};

const Toast = ({ type, heading, description }) => {
  const getIcon = () => {
    switch (type) {
      case ToastType.SUCCESS:
        return successGreenIcon;
      case ToastType.ERROR:
        return errorIcon;
      case ToastType.WARNING:
      case ToastType.INFO:
        return warningIcon;
      default:
        return null;
    }
  };

  return (
    <div className="toastContainer">
      <img src={getIcon()} alt="" width={20} height={20} />
      <div className="toastContent">
        <div className="toastHeading">{heading}</div>
        <div className="toastDescription">{description}</div>
      </div>
    </div>
  );
};

export default Toast;
